import {
  Box,
  Stack,
  Typography,
  Tooltip as TooltipMUI,
  Fade,
  tooltipClasses,
  styled,
} from "@mui/material";
import React, { useState } from "react";
import CustomColorPicker from "../../../CustomColorPicker";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import AddIcon from "@mui/icons-material/Add";
import { TextView } from "@components";
import { ReactComponent as ColorPicker } from "@assets/images/colorPicker.svg";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import "./style.css";

function SegmentColorsBox({
  defaultColors,
  onClickDefaultColor,
  onClickCustomColor,
  values,
  index,
  temporaryColor,
  handleTemporaryColorChange,
  onConfirmCustomColor,
  myColors,
  colorType,
  handleColorEditClick,
  colorPickerVisible,
  setColorPickerVisible,
  onAddIconClick,
  handleClose,
}) {
  const ToBeStyledTooltip = ({ className, ...props }) => (
    <TooltipMUI {...props} classes={{ tooltip: className }} />
  );
  const TooltipMaterialUI = styled(ToBeStyledTooltip)({
    backgroundColor: "#123051",
    borderRadius: "4px",
    color: "white",

    "& .MuiTooltip-arrow": {
      color: "#123051",
    },
  });

  return colorPickerVisible ? (
    <CustomColorPicker
      customStyle={{ position: "fixed", left: "70.5vw", bottom: "14vh" }}
      visible={colorPickerVisible}
      onClose={() => setColorPickerVisible(false)}
      onConfirm={onConfirmCustomColor}
      color={temporaryColor}
      onColorChange={handleTemporaryColorChange}
    />
  ) : (
    <Box
      sx={{
        backgroundColor: "white",
        width: "264px",
        p: 2,
        mt: 2,
        borderRadius: "8px",
        boxShadow:
          "0px 10px 15px 0px rgba(31, 41, 55, 0.10), 0px 4px 6px 0px rgba(31, 41, 55, 0.05);",
        position: "fixed",
        zIndex: 1000,
        right: "calc(100vw - 84% - 15px)",
      }}
    >
      <Stack
        display={"flex"}
        flexDirection={"row"}
        justifyContent={"space-between"}
      >
        <Stack
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"flex-start"}
          alignItems={"center"}
          gap={"8px"}
        >
          <ColorPicker
            className="icon"
            style={{ height: "25px", width: "25px", marginRight: "4px" }}
          />

          <TextView
            style={{
              fontSize: "18px",
              fontWeight: "500",
              color: "#565556",
            }}
          >
            Segment Color
          </TextView>
        </Stack>

        <CloseOutlinedIcon
          onClick={handleClose}
          style={{ color: "#123051", cursor: "pointer" }}
        />
      </Stack>
      <TextView
        style={{
          fontSize: "16px",
          fontWeight: "500",
          color: "#565556",
          marginTop: "10px",
          marginBottom: "3px",
        }}
      >
        Default
      </TextView>

      <div
        style={{
          display: "flex",
          alignSelf: "start",
        }}
      >
        <div
          style={{
            display: "flex", // Use flexbox to layout children
            flexWrap: "wrap", // Allow items to wrap to the next line
            maxWidth: "100%", // Adjust the width based on 7 items (18px width + 4px margin) * 7
          }}
        >
          {defaultColors?.map((cat) => (
            <TooltipMaterialUI
              placement="top"
              arrow
              title={cat?.color?.outer_color_code}
              TransitionComponent={Fade}
              TransitionProps={{ timeout: 600 }}
              followCursor
            >
              <div
                key={cat.color.id} // Use a unique key for each item
                style={{
                  backgroundColor: "white",
                  borderRadius: "100%",
                  width: "26px",
                  height: "26px",
                  margin: "4px",
                  marginRight: "6px",

                  border:
                    values.chart[index].color === cat.color.outer_color_code &&
                    "3px solid #565556",

                  display: "flex",

                  justifyContent: "center",
                  alignItems: "center",
                }}
                onClick={() => onClickDefaultColor(cat)}
              >
                <div
                  style={{
                    backgroundColor: cat?.color?.outer_color_code,
                    borderRadius: "100%",
                    width:
                      values.chart[index].color === cat.color.outer_color_code
                        ? "16px"
                        : "26px",
                    height:
                      values.chart[index].color === cat.color.outer_color_code
                        ? "16px"
                        : "26px",
                    // margin: "4px",
                  }}
                ></div>
              </div>
            </TooltipMaterialUI>
          ))}
        </div>
      </div>

      <Stack
        display={"flex"}
        flexDirection={"row"}
        justifyContent={"space-between"}
        marginTop={"12px"}
        mb={1}
      >
        <TextView
          style={{ fontSize: "16px", fontWeight: "500", color: "#565556" }}
        >
          Custom
        </TextView>

        <Stack
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"flex-end"}
          alignItems={"center"}
        >
          {colorType === "My" && (
            <>
              <EditOutlinedIcon
                onClick={handleColorEditClick}
                style={{
                  fontSize: "12px",
                  cursor: "pointer",
                  marginRight: "3px",
                }}
              />
              <TextView
                onClick={handleColorEditClick}
                style={{
                  cursor: "pointer",
                  fontWeight: "500",
                  color: "#6B7280",
                  fontSize: "10px",
                }}
              >
                Edit
              </TextView>
            </>
          )}
          <AddIcon
            style={{
              fontSize: "12px",
              cursor: "pointer",
              color: "#6B7280",
              marginRight: "-1px",
              marginLeft: "3px",
            }}
            onClick={onAddIconClick}
          />
          <TextView
            onClick={onAddIconClick}
            style={{
              cursor: "pointer",
              fontWeight: "500",
              color: "#6B7280",
              fontSize: "10px",
            }}
          >
            Add New
          </TextView>
        </Stack>
      </Stack>
      <div
        style={{
          display: "flex",
          alignSelf: "start",
        }}
      >
        <div
          style={{
            display: "flex", // Use flexbox to layout children
            flexWrap: "wrap", // Allow items to wrap to the next line
            maxWidth: "100%", // Adjust the width based on 7 items (18px width + 4px margin) * 7
          }}
        >
          {myColors.length ? (
            myColors?.map((cat) => (
              // <OverlayTrigger
              //   key={cat?.color.id}
              //   placement={"top"}
              //   overlay={
              //     <Tooltip id={"tooltip"} className="custom-tooltip">
              //       {cat?.color?.outer_color_code}
              //     </Tooltip>
              //   }
              // >
              <TooltipMaterialUI
                placement="top"
                arrow
                title={cat?.color?.outer_color_code}
                TransitionComponent={Fade}
                TransitionProps={{ timeout: 600 }}
                followCursor
              >
                <div
                  style={{
                    backgroundColor: "white",
                    borderRadius: "100%",
                    width: "26px",
                    height: "26px",
                    margin: "4px",
                    marginRight: "6px",

                    border:
                      values.chart[index].color ===
                        cat.color.outer_color_code && "3px solid #565556",

                    display: "flex",

                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  onClick={() => onClickCustomColor(cat)}
                >
                  <div
                    style={{
                      backgroundColor: cat?.color?.outer_color_code,
                      borderRadius: "100%",
                      width:
                        values.chart[index].color === cat.color.outer_color_code
                          ? "16px"
                          : "26px",
                      height:
                        values.chart[index].color === cat.color.outer_color_code
                          ? "16px"
                          : "26px",
                      // margin: "4px",
                    }}
                  ></div>
                </div>
              </TooltipMaterialUI>
            ))
          ) : (
            <TextView
              style={{
                fontSize: "12px",
                fontWeight: "500",
                color: "#BBBBBB",
              }}
            >
              Start crafting your own unique colors!
            </TextView>
          )}
        </div>
      </div>
    </Box>
  );
}

export default SegmentColorsBox;
